import { gsap } from 'gsap';

export default class Instagram {
  constructor(marquee) {
    this.dom = {
      marquee,
      marqueeContent: marquee.querySelector('.marquee-content'),
    };

    if (!this.dom.marqueeContent) return;

    this.mount();
  }

  mount() {
    const { marquee, marqueeContent } = this.dom;

    if (!marquee.dataset.cloned) {
      const clone = marqueeContent.cloneNode(true);
      marquee.appendChild(clone);
      marquee.dataset.cloned = 'true';
    }

    const direction = parseInt(marqueeContent.dataset.direction || '-1', 10);

    const width = marqueeContent.offsetWidth;

    const fromX = direction === 1 ? -width : 0;
    const toX = direction === 1 ? 0 : -width;

    gsap.fromTo(
      marquee.children,
      { x: fromX },
      {
        x: toX,
        duration: 200,
        ease: 'none',
        repeat: -1,
      },
    );
  }
}
